<div [ngStyle]="{ 'max-width.px': videoWidth, 'max-height.px': videoHeight }">
  <style>wistia-player[media-id="{{videoSrc}}"]:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/{{videoSrc}}/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
  <div #wistiaPlayerContainer></div>
</div>
